<template>
  <section class="tw-pt-32 md:tw-pt-40 lg:tw-pt-48">
    <div class="container">
      <nav
        class="tw-flex tw-w-full tw-items-center tw-justify-start tw-bg-transparent"
        aria-label="breadcrumb"
        v-if="breadcrumbs.length > 1"
      >
        <ol class="tw-flex tw-items-center tw-gap-2 tw-bg-transparent tw-p-0 tw-uppercase">
          <li
            v-for="(crumb, idx) in breadcrumbs"
            :key="idx"
            class="tw-inline-flex tw-items-center tw-gap-1 tw-transition-colors tw-duration-150"
            :class="{ 'active tw-text-primary tw-font-semibold': idx === breadcrumbs.length - 1 }"
            aria-current="page"
          >
            <template v-if="idx !== breadcrumbs.length - 1">
              <nuxt-link
                :external="true"
                class="n-link hover:tw-text-primary tw-flex tw-items-center tw-transition-colors tw-duration-150"
                :to="crumb.to"
              >
                <h5>
                  {{ crumb.text }}
                </h5>
              </nuxt-link>
              <span style="color: var(--c-text_secondary) !important" class="tw-pl-1">/</span>
            </template>
            <h5 v-else style="color: var(--c-text_primary) !important">{{ crumb.text }}</h5>
          </li>
        </ol>
      </nav>
    </div>
  </section>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useRoute } from '#imports';

const props = defineProps<{
  theme?: string;
}>();

const route = useRoute();

// Optionally, you can map route segments to more user-friendly names here
const nameMap: Record<string, string> = {
  '': 'Home',
  properties: 'Properties',
  blog: 'Blogs',
  // Add more mappings as needed
};

const breadcrumbs = computed(() => {
  const pathArray = route.path.split('/').filter(Boolean);
  const crumbs = [{ text: nameMap[''] || 'Home', to: '/' }];
  let currentPath = '';
  
  if (pathArray[0] === 'properties') {
    // Always show /properties and then /property, regardless of the rest
    currentPath = '/properties';
    crumbs.push({
      text: nameMap['properties'] || 'Properties',
      to: currentPath,
    });
    if (pathArray.length > 1) {
      currentPath += '/Detail';
      crumbs.push({
        text: 'Detail',
        to: currentPath,
      });
    }
    return crumbs;
  }
  
  // Special handling for blogs in theme9
  if (pathArray[0] === 'blogs' && props.theme === 'theme9') {
    currentPath = '/blogs';
    crumbs.push({
      text: 'Blogs',
      to: currentPath,
    });
    if (pathArray.length > 1) {
      // Blog detail page - show only "Detail" instead of blog title
      crumbs.push({
        text: 'Detail',
        to: route.path,
      });
    }
    return crumbs;
  }
  
  pathArray.forEach((segment) => {
    currentPath += '/' + segment;
    crumbs.push({
      text: nameMap[segment] || segment.replace(/-/g, ' ').replace(/\b\w/g, (l) => l.toUpperCase()),
      to: currentPath,
    });
  });
  return crumbs;
});
</script>

<style scoped>
.breadcrumb {
}
.breadcrumb-item.active {
}
</style>
